import * as React from "react";
import * as Helpers from "../helpers";
import styles from "./InputSelect.module.scss";

type InputSelectProps = InputProps & {
    disabled?: boolean;
    options: OptionItem[];
};

const InputSelect: React.FunctionComponent<InputSelectProps> = props => {
    const isRequired = props.required === true || (Array.isArray(props.required) && props.required.indexOf("required") !== -1);
    const showValidation = !Helpers.TriggerValidationSingle((props.value || "").trim(), props.required) && props.validation_triggered;
    const elemRef = React.useRef<HTMLDivElement>(null);
    if (showValidation && !props.validation_get_scrolled() && elemRef.current) {
        props.validation_set_scrolled();
        elemRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
    }

    return <div ref={elemRef} className={styles.outer}>
        <div className={`${styles.wrapper} ${showValidation ? styles.hasValidation : ""}`}>
            <label htmlFor={props.name}>
                {props.label} {props.required ? <sub className={styles.required}>*</sub> : null}
            </label>
            <select
                className={`form-control ${styles.formControl}`}
                id={props.name}
                name={props.name}
                value={props.value || ''}
                required={isRequired}
                onChange={(ev) => (props.update_value(props.name, ev.currentTarget.value))}
                disabled={!!props.disabled}
            >
                <option value="">Please select...</option>
                {props.options.map(item =>
                    <option key={item.value} value={item.value}>{item.label}</option>
                )}
            </select>
        </div>
        {props.description}
        {showValidation ? <div className={styles.validation} role="alert">{props.validation_message ? <>{props.validation_message}</> : <>Please select a <span style={{ textTransform: "lowercase" }}>{props.label}</span>.</>}</div> : null}
    </div>;
}

export default InputSelect;